import { triggersNamespace } from "../triggers-namespace";

export const timeNamespace = `${triggersNamespace}time/`